// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header[data-v-ddb6eaec]{display:flex}.header H1[data-v-ddb6eaec]{flex:1}", ""]);
// Exports
module.exports = exports;
